import { render, staticRenderFns } from "./PayOrRequest.vue?vue&type=template&id=133002fc&"
import script from "./PayOrRequest.vue?vue&type=script&lang=js&"
export * from "./PayOrRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports